export default "__VITE_ASSET__C5$D7YeN__"